import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { CheckCircle2, TrendingUp, ArrowRight } from 'lucide-react';

const Investering = () => {
  return (
    <div className="py-16 bg-white">
      <Helmet>
        <title>Investering: Uvildig investeringsrådgivning</title>
        <meta name="description" content="Vores rådgivning om investering tager udgangspunkt i at minimere dine omkostninger og sikre dig størst muligt afkast baseret på dine mål. Se mere her" />
      </Helmet>

      <div className="container mx-auto px-4 max-w-4xl">
        <nav className="text-sm text-slate-500 mb-8 flex items-center space-x-2">
          <Link to="/" className="hover:text-[#b60f00]">Forsiden</Link>
          <span>/</span>
          <span className="text-slate-900 font-medium">Investering</span>
        </nav>

        <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-10 break-words">Investering</h1>

        <div className="prose prose-slate prose-lg max-w-none mb-12">
          <p>
            Investeringsrådgivning hos FinansOptimering handler om at sikre dig det størst mulige afkast med de lavest mulige omkostninger. Vi tager altid udgangspunkt i din risikovillighed, tidshorisont og dine personlige mål.
          </p>
          <p>
            Uanset om det drejer sig om frie midler, pensionsopsparing eller virksomhedsmidler, hjælper vi dig med at navigere i et komplekst marked og finde de mest skatteoptimale løsninger.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {[
            "Hvordan får jeg det største afkast af mine midler?",
            "Skal jeg indfri gæld eller investere?",
            "Hvilken risikoprofil passer til min situation?",
            "Hvordan optimerer jeg skatten af mine investeringer?"
          ].map((q, i) => (
            <div key={i} className="bg-red-50 p-6 rounded-2xl border border-red-100 flex items-start">
              <CheckCircle2 className="text-[#b60f00] mr-4 shrink-0 mt-1" size={20} />
              <p className="text-slate-800 font-medium leading-relaxed">{q}</p>
            </div>
          ))}
        </div>

        <div className="text-center mb-16">
          <Link 
            to="/kontakt-os" 
            className="inline-flex items-center bg-[#b60f00] text-white px-10 py-4 rounded-xl font-bold hover:bg-[#a00d00] transition-all shadow-md active:scale-95"
          >
            Bestil et gratis uforpligtende møde her
          </Link>
        </div>

        <div className="prose prose-slate prose-lg max-w-none mb-12">
          <h2 className="text-3xl font-bold text-slate-900 mb-6">Fokus på lave omkostninger</h2>
          <p>
            Da ingen præcist kan forudsige markedet, er lave omkostninger og god spredning de vigtigste faktorer for et godt langsigtet afkast. Vi hjælper dig med at vælge de rigtige fonde og undgå skjulte gebyrer.
          </p>
          
          <div className="bg-slate-900 text-white p-8 rounded-3xl my-10 shadow-xl">
            <div className="flex items-center mb-4">
              <TrendingUp className="text-[#b60f00] mr-3" size={24} />
              <h4 className="text-xl font-bold">Vidste du det?</h4>
            </div>
            <p className="text-slate-300 text-lg leading-relaxed">
              En forskel i ÅOP på blot 1,0% kan betyde en forskel på 10.000 kr. årligt for hver million, du har investeret.
            </p>
          </div>

          <h2 className="text-3xl font-bold text-slate-900 mt-16 mb-6">Løbende opfølgning</h2>
          <p>
            Vi anbefaler minimum et årligt opfølgningsmøde, hvor vi rebalancerer dine depoter og sikrer, at din strategi stadig passer til dine mål og markedssituationen.
          </p>
        </div>

        <div className="mt-12 text-center">
          <Link 
            to="/kontakt-os" 
            className="text-[#b60f00] font-bold text-xl hover:underline flex items-center justify-center"
          >
            Kontakt os og aftal et møde <ArrowRight className="ml-2" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Investering;
